import React from 'react';
import { CloudOffIcon } from 'lucide-react';
interface NowConnectionNoticeProps {
  isOnline: boolean;
}
export function NowConnectionNotice({
  isOnline
}: NowConnectionNoticeProps) {
  if (isOnline) return null;
  return <div className="fixed inset-x-3 top-[calc(env(safe-area-inset-top)+8px)] z-[90] rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 text-amber-900 shadow-[0_6px_18px_rgba(120,80,10,0.12)] md:hidden" role="status" data-id="element-4376" data-mp="266jkecfo90sd">
    <div className="flex items-center gap-2" data-id="element-4377" data-mp="1w83pdydix7dl"><CloudOffIcon className="h-4 w-4 shrink-0" data-id="element-4378" data-mp="2189m3synhk2j" /><p className="text-xs font-semibold" data-id="element-4379" data-mp="219awrwbr84jq">Weak connection. Your cart and recent actions are saved on this device.</p></div>
  </div>;
}